import api from "../api";
import Api from "../api";

/**
 * Validates an IBAN
 * @param {string} iban - The IBAN to validate
 * @returns {Promise} API response
 */
export const validateIban = async (iban) => {
  try {
    const response = await Api.getApi().post(
      api.getBaseUrl() + "iban/validate",
      { iban }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Validates multiple IBANs
 * @param {string[]} ibans - Array of IBANs to validate
 * @returns {Promise} API response
 */
export const validateMultipleIbans = async (ibans) => {
  try {
    const response = await Api.getApi().post(
      api.getBaseUrl() + "iban/validate-multiple",
      {
        ibans,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Gets supported countries for IBAN validation
 * @returns {Promise} API response
 */
export const getSupportedCountries = async () => {
  try {
    const response = await Api.getApi().get(
      api.getBaseUrl() + "iban/countries"
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Gets sample IBAN for a specific country
 * @param {string} countryCode - Country code (e.g., 'TR', 'DE')
 * @returns {Promise} API response
 */
export const getSampleIban = async (countryCode) => {
  try {
    const response = await Api.getApi().get(
      api.getBaseUrl() + `iban/sample/${countryCode}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
